enum CommunicationType {
	Email = "Email"
}

export default CommunicationType;